import React, {Component} from 'react';
import './ToiStructure.style.scss';
import {Cell, Label, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import pie from 'assets/icons/pie-icon.svg';

function CustomLabel({viewBox, value}) {
  const {cx, cy} = viewBox;
  return (
    <svg className='recharts-text recharts-label' textAnchor='middle' dominantBaseline='central'>
      <text x={cx} y={cy}>
        <tspan
          x={cx}
          dy='0em'
          alignmentBaseline='middle'
          fontSize='20'
          fill='#0B0B0A'
          fontWeight={600}>
          {value}
        </tspan>
      </text>
    </svg>
  );
}

export default class ToiStructure extends Component {
  render() {
    const data = [
      {name: 'NII', key: 'i', value: 78},
      {name: 'Non Interest Income', key: 'l', value: 22},
    ];
    const COLORS = ['#FBC83A', '#EBEBEB'];
    return (
      <div className='toi-container'>
        <h1 className='toi-title'>
          <img src={pie} alt='' style={{marginRight: 8}} />
          TOI STRUCTURE
        </h1>
        <ResponsiveContainer width='100%' height={300}>
          <PieChart>
            <Pie
              paddingAngle={0}
              data={data}
              dataKey='value'
              cx='50%'
              cy='50%'
              outerRadius={125}
              innerRadius={85}
              startAngle={90}
              endAngle={-450}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  borderWidth={0}
                  stroke={0}
                />
              ))}
              <Label width={80} position='center' content={<CustomLabel value={'68,083'} />} />
            </Pie>
            <Legend
              wrapperStyle={{
                paddingTop: '16px',
              }}
              layout='horizontal'
              align='center'
              verticalAlign='bottom'
              formatter={(value, entry) => {
                const {payload} = entry;
                return (
                  <span style={{color: '#0B0B0A', fontSize: 14}}>
                    {value}
                    {'  '}
                    <span style={{color: '#0B0B0A', fontSize: 14, fontWeight: 600}}>
                      {payload.value}%
                    </span>
                  </span>
                );
              }}
            />
            <Tooltip cursor={false} content={<CustomTooltip data={data} colors={COLORS} />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
const CustomTooltip = (props) => {
  const {active, payload, data, colors} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;
    const index = data.findIndex((el) => el.name === item.name);

    return (
      <div className='custom-tooltip' style={{backgroundColor: colors[index % data.length]}}>
        <span className='name'>{item.name}</span>
        <span className='desc'>{item.value}%</span>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/ToiStructure/ToiStructure.js